/**
 * Chatbot presentation (visibility, placeholder copy, PO tools) comes from the
 * layout `visible` key (the same key Main uses to mount a store page).
 * Subjects are shared across pages, so they must not identify a conversation;
 * see `toChatbotConversationScope` for that.
 */

const ASK_QV_AI_PAGE = 'ask-quickvee-ai';

const subjectForKeys = (subject, keys) =>
  keys.reduce((map, key) => {
    map[key] = subject;
    return map;
  }, {});

const PAGE_SUBJECTS = {
  ...subjectForKeys('the dashboard', [
    'dashboard',
    'node-dashboard',
    'dashboard-chart-view-reports',
    'node-dashboard-chart-view-reports',
  ]),
  ...subjectForKeys('orders', [
    'order',
    'order-online',
    'order-new',
    'order-online-new',
    'order-summary',
  ]),
  ...subjectForKeys('customers', [
    'customer-management',
    'dashboard-customer',
    'dashboard-customer-addCustomer',
    'dashboard-customer-editCustomer',
    'dashboard-customer-viewCustomer',
    'store-groups',
    'create-group',
    'edit-group',
    'customer-feed',
    'new-customers-added-report',
    'customer-reports',
  ]),
  ...subjectForKeys('products', [
    'products',
    'new-products',
    'new-product-add',
    'new-product-edit',
    'new-product-duplicate',
    'new-product-sales',
    'product-edit',
    'productedit',
    'product-add',
    'duplicate-product',
    'product-sales',
    'edit-varient',
    'stock-on-hand',
    'inventory-transfer',
    'bulk-product-update',
    'attributes',
    'old-attributes',
    'category',
    'add-category',
    'category-edit-cat',
    'brands',
    'old-brands',
    'tags',
    'old-tags',
    'variants',
    'inventory',
    'inventory-merge',
    'inventory-export-merchant',
    'composite-items',
    'composite-operations',
    'product-lookups',
    'import-data',
    'audit-log',
  ]),
  ...subjectForKeys('purchase orders', [
    'new-purchase-order',
    'new-purchase-order-add',
    'new-purchase-order-detail',
    'add-po',
    'modify-purchase-order',
    'add-purchase-data',
    'edit-purchase-data',
  ]),
  ...subjectForKeys('vendors', [
    'vendors',
    'add-vendors',
    'old-vendors',
    'vendors-list',
    'edit-vendor',
    'vendor-details',
    'new-vendor-details',
    'vendors-sales-reports',
  ]),
  ...subjectForKeys('stocktake', [
    'stocktake',
    'stocktake-app-list',
    'stocktake-app-session',
    'stocktake-updateStocktake',
    'stocktake-AddStocktake',
    'stocktake-void',
    'stocktake-completed',
  ]),
  ...subjectForKeys('promotions', [
    'coupons',
    'add-coupons',
    'coupons-edit-cop',
    'order-coupons',
    'add-order-coupons',
    'order-coupons-edit-cop',
    'item-coupons',
    'add-item-coupons',
    'item-coupons-edit-cop',
    'mix-and-match',
    'add-mix-and-match',
    'update-mix-and-match',
    'bogo-pricing',
    'bogo-pricing-add',
    'product-and-category-discounts',
    'product-and-category-discounts-add-edit',
    'Digital-marketing-tags',
    'loyalty-program',
    'StoreSettingloyalty-program',
    'StoreSettingloyalty-program2',
    'coupon-report',
  ]),
  ...subjectForKeys('employees', [
    'timesheet',
    'timesheets',
    'newTimesheet',
    'TimeSheet-Summery-Table',
    'addemployee',
    'manage-employees',
    'manage-employee-permissions',
    'permission-presets',
    'permission-presets-add',
    'permission-presets-edit',
    'employee-list',
    'permission',
    'employee-reports',
    'employee-ratings-report',
    'employee-sales-per-category-report',
  ]),
  ...subjectForKeys('sales', [
    'new-sale-report',
    'sales-report',
    'old-sales-summery',
    'toptraders',
    'overall-top',
    'item-sales',
    'new-item-sales-report',
    'item-sales-profit-report',
    'category-sales-summery-report',
    'sales-by-hour-report',
    'Details-category',
    'report-sales-person',
    'daily-total-report',
    'order-type',
    'discount-per-sales-person',
    'item-sold-report',
    'category-sold-report',
    'item-sold-data',
  ]),
  ...subjectForKeys('inventory reports', [
    'inventory-report',
    'current-inventory-value',
    'inventory-list',
    'recorder-inventory',
    'item-create-between',
    'profit-Margin',
    'instant-activity',
    'po-products-report',
  ]),
  ...subjectForKeys('payments', [
    'payment-report',
    'payment-method-details',
    'pay-in-report',
    'pay-ins-and-payout',
    'drop-cash-report',
    'tip-report',
  ]),
  ...subjectForKeys('refunds', [
    'refund-report',
    'refund-report-main',
    'order-refund-report',
  ]),
  ...subjectForKeys('register activity', [
    'register-closures',
    'register-closures-summery',
    'register-closures-transactions',
    'shift-summary',
    'flash-resigter',
  ]),
  ...subjectForKeys('loyalty', ['detailed-loyalty-points-report']),
  ...subjectForKeys('store credit', ['store-credit-report']),
  ...subjectForKeys('gift cards', ['gift-card-report']),
  ...subjectForKeys('taxes', ['taxes', 'taxes-report', 'new-taxes-report']),
  ...subjectForKeys('locations', ['location-report']),
  ...subjectForKeys('Uber', ['uber-reports']),
  ...subjectForKeys('lottery', [
    'lottery',
    'add-lottery',
    'update-lottery',
    'lottery-payout-report',
  ]),
  ...subjectForKeys('store settings', [
    'info',
    'setup',
    'options',
    'Alters',
    'register',
    'system-access',
    'breaks-and-compliance',
    'receipt',
    'store-setting',
    'zoho-connect',
    'hq-connect',
    'quickbooks',
    'zohoProductMapping',
    'scan-data-AltriaForm',
    'scan-data-ReynoldsForm',
    'scan-data-Dezi',
    'scan-data-SyncedProducts',
    'scan-data-SentReports',
    'scan-data-ManualUpload',
    'need_help',
    'store',
    'manager',
    'id-verification',
  ]),
};

const fallbackSubject = (pageKey) => {
  const words = String(pageKey)
    .replace(/[_]+/g, ' ')
    .replace(/-+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
  return words || 'this page';
};

const PURCHASE_ORDER_PAGE_KEYS = new Set([
  'new-purchase-order',
  'new-purchase-order-add',
  'new-purchase-order-detail',
  'add-po',
  'modify-purchase-order',
  'add-purchase-data',
  'edit-purchase-data',
]);

/** Temporary: the store chatbot launcher is dashboard-only. */
const CHATBOT_VISIBLE_PAGE_KEYS = new Set(['dashboard']);

export const getChatbotPageContext = (pageKey) => {
  const key = String(pageKey || '').trim();
  if (!key || key === ASK_QV_AI_PAGE || !CHATBOT_VISIBLE_PAGE_KEYS.has(key)) {
    return {
      hidden: true,
      placeholder: '',
      purchaseOrderPdf: false,
    };
  }

  const subject = PAGE_SUBJECTS[key] || fallbackSubject(key);
  return {
    hidden: false,
    placeholder: `Ask me anything about ${subject}...`,
    purchaseOrderPdf: PURCHASE_ORDER_PAGE_KEYS.has(key),
  };
};
